var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "17px",
    viewBox: "0 0 28 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "67.3628827%",
    x2: "0%",
    y2: "32.6371173%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3AA2",
    offset: "0.0928758741%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF891C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1\\u5907\\u4EFD",
    transform: "translate(-234.000000, -124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u793C\\u5305",
    transform: "translate(234.000000, 124.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L27,0 C27.5522847,-1.01453063e-16 28,0.44771525 28,1 L28,12.5 C28,14.709139 26.209139,16.5 24,16.5 L1,16.5 C0.44771525,16.5 -3.76453835e-16,16.0522847 0,15.5 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "MicrosoftYaHei, Microsoft YaHei",
    fontSize: 11,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 12.234375
  }, "\u793C\u5305")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGift);
export default __webpack_public_path__ + "static/media/search_gift.a8aa9e26a4f25f4fb143b2e4b9aa4707.svg";
export { ForwardRef as ReactComponent };